import { ref, watch } from '@vue/composition-api'
import {useRouter} from '../../../../core/hooks'

const useRequestExpand = () => {

    const expandedRow = ref(null)

    const {route} = useRouter();

    const toggleExpand = id => {
        expandedRow.value = expandedRow.value === id ? null : id
    }

    watch(route, route => {
        expandedRow.value = route.query.id || null
    }, {immediate: true})

    return {
        expandedRow,
        toggleExpand
    }
}
export default useRequestExpand